import { icon, Icon } from '../lib/fa-icons.js';
/*
Place this widget just before the closing tag of the .Article__Main element
*/
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class BumperHoliday25Widget extends Widget {
	componentWillMount() {
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;
		this.toggleShrink = this.toggleShrink.bind(this);

		console.log(getCookie("tpm_bumper_holiday_25_shrunk"));
		if (getCookie("tpm_bumper_holiday_25_shrunk") === "1") {
			this.state.shrunk = true;
		}

		document
			.querySelector(".js_site-footer")
			.setAttribute("style", "padding-bottom: 100px");
	}

	componentDidMount() {
		window.bh25 = this;
		window.addEventListener("scroll", this.scrollWatcher);
		document
			.querySelector("body")
			.setAttribute("style", "padding-bottom: 80px");
	}

	scrollWatcher() {
		let el = document.querySelector(".js_article-content");

		if (window.scrollY > el.getBoundingClientRect().top) {
			bh25.slideUp();
			window.removeEventListener("scroll", this.scrollWatcher);
		}
	}

	slideUp() {
		document
			.querySelector(".BumperHoliday25Widget")
			.classList.add("--slide-up");
	}

	toggleShrink(e) {
		e.preventDefault();
		e.stopPropagation();
		const shrunk = !this.state.shrunk;
		if (shrunk) {
			setCookie("tpm_bumper_holiday_25_shrunk", "1", 1);
		} else {
			setCookie("tpm_bumper_holiday_25_shrunk", "0", 1);
		}

		this.setState({ shrunk: shrunk });
	}

	get hrefDirect() {
		return `https://talkingpointsmemo.com/memberships`;
	}

	renderContent() {
		if (this.state.shrunk || document.body.getBoundingClientRect().width < 360)
			return (
				<div className={`BumperHoliday25`}>
					<div
						className={`BumperHoliday25__Inner ${
							this.props.thick ? "--thick" : ""
						}`}
					>
						<div className="BumperHoliday25__Top --shrunk">
							<div className="BumperHoliday25__TopRight">
								<img
									src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/holiday25/tpm-gift-single.png`}
									aria-hidden="true"
									className="BumperHoliday25__GiftBox --shrunk"
								/>
								<div className="BumperHoliday25__Body --shrunk">
									<p className="big">TPM Holiday Sale</p>
								</div>
								<div className="BumperHoliday25__Buttons">
									<a href={this.hrefDirect} className="Button --navy">
										25% Off Annual Memberships
									</a>
								</div>
								<div
									className="BumperHoliday25__Shrink --shrunk"
									onClick={this.toggleShrink}
								>
									<Icon name={this.state.shrunk ? 'angle-up' : 'angle-down'} style="light" />
								</div>
							</div>
						</div>
					</div>
				</div>
			);

		return (
			<div className={` BumperHoliday25 `}>
				<div
					className={`BumperHoliday25__Inner ${
						this.props.thick ? "--thick" : ""
					}`}
				>
					<div className="BumperHoliday25__Top">
						<div
							className="BumperHoliday25__Shrink"
							onClick={this.toggleShrink}
						>
							<Icon name={this.state.shrunk ? 'angle-up' : 'angle-down'} style="light" />
						</div>
					</div>
					<div className="BumperHoliday25__Body">
						<div>
							<img
								src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/holiday25/tpm-gift-single.png`}
								aria-hidden="true"
								className="BumperHoliday25__GiftBox"
							/>
							<p className="big">TPM Holiday Sale</p>

							<div className="BumperHoliday25__Buttons --margin">
								<a href={this.hrefDirect} className="Button --navy">
									25% Off Annual Memberships
								</a>
							</div>

							<p className="small">
								Help us keep building a better kind of media company
							</p>
						</div>
					</div>
				</div>
				<div className="BumperHoliday25__SideSpacer"></div>
			</div>
		);
	}
}
